<template>
    <div class="flex-1">
        <skeleton v-if="planBookingPage === undefined" />
        <not-found v-else-if="planBookingPage === null" />
        <not-found
            v-else-if="planBookingPage.__typename === 'InvalidBookingPage'"
            :title="planBookingPage.title"
            :reason="planBookingPage.reason"
        />
        <not-found
            v-else-if="!planBookingPage.active"
            reason="This plan is inactive. If you are attempting to make a booking or purchase, please contact the facility to resolve the issue."
        />
        <purchase-membership
            v-else
            :plan="planBookingPage"
            :is-editing="false"
        />
    </div>
</template>

<script setup lang="ts">
import { useRoute } from '#app'
import { computed } from 'vue'
import PurchaseMembership from '~/components/PurchaseContract/Membership/PurchaseMembership.vue'
import { useQuery } from '@tanstack/vue-query'
import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import Skeleton from 'primevue/skeleton'
import NotFound from '~/components/NotFound/NotFound.vue'
import { useCurrentDate } from '~/composables/use-current-date'

const route = useRoute()
const slug = computed(() => route.params.slug)
const activeFacility = useActiveFacility()

const query = useRpQuery()
const currentDate = useCurrentDate()
const reactiveDate = computed(() => currentDate.value.getDate())
const { data } = useQuery({
    queryKey: ['MembershipsPageQuery', slug, activeFacility, reactiveDate],
    queryFn: () =>
        query(
            graphql(/* GraphQL */ `
                query MembershipsPageQuery(
                    $bookingInput: PlanBookingPageInput!
                    $facilityId: ID!
                    $input: SimpleSpokeInput!
                ) {
                    planBookingPage(input: $bookingInput) {
                        __typename
                        ... on InvalidBookingPage {
                            title
                            reason
                        }
                        ... on Plan {
                            ...PurchaseMembershipPlanFragment
                            active
                        }
                    }
                }
            `),
            {
                facilityId: activeFacility.value.id,
                input: {
                    facilityId: activeFacility.value.id
                },
                bookingInput: {
                    slug: slug.value,
                    facilityId: activeFacility.value.id,
                    planType: 'MEMBERSHIP'
                }
            }
        )
})

const planBookingPage = computed(() => {
    if (data.value === undefined) {
        return undefined
    }

    if (data.value.planBookingPage === null) {
        return null
    }

    return data.value.planBookingPage
})
</script>
